
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty/createAccount/createAccountPage1",
      function () {
        return require("private-next-pages/loyalty/createAccount/createAccountPage1/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty/createAccount/createAccountPage1"])
      });
    }
  